import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BackgroundFX from "@/components/site/BackgroundFX";
import Portfolio from "@/components/site/Portfolio";

export const PortfolioPage = () => {
  return (
    <main className="relative bg-[#F7F6F3] text-[#1A1A1A] overflow-x-hidden">
      <BackgroundFX />
      <div className="relative z-10">
        <Navbar />
        {/* Top spacer so the fixed nav doesn't cover the first heading */}
        <div className="pt-24" />
        <Portfolio />
        <Footer />
      </div>
    </main>
  );
};

export default PortfolioPage;
